import logo from "../assets/images/icon_rounded.png"
import logoDark from "../assets/images/icon_dark_rounded.png"

export const lightTheme = {
	notMainChainTextColor: "#FFF",
	notMainChainBackgroundColor: "red",
    body: "#FFF",
    text: "#000",
    logo: logo,
    brandTextColor: "#000",
    brandTextColorHover: "#000",
    headerBackground: "inherited",
    footerBackgroundColor: "#FFF",
    oraclePanelBackgroundColor: "#FFF",
    panelTextColor: "#000",
    panelBorderColor: "#EEE",
    panelShadow: "0 3px 8px 0 rgb(160 164 167 / 30%), 0 20px 30px 15px rgb(160 164 167 / 15%)",
    inputPanelBackgroundColor: "#f5f7f6",
    inputPanelTextColor: "#000",
    inputPanelBorderColor: "#EEE",
    inputPanelBorderColorHover: "#AAA",
    oracleButtonBackgroundColor: "#EA0067",
    oracleButtonTextColor: "#FFF",
    oracleButtonBackgroundNotReadyColor: "#444",
    oracleButtonTextNotReadyColor: "#FFF",
    currencyTextColor: "#000",
    currencyBackgroundColor: "#F7F7F7",
    emptyCurrencyTextColor: "#FFF",
    emptyCurrencyBackgroundColor: "#1DDD94",
    currencyShadow: "0 3px 3px 0 rgb(160 164 167 / 30%), 0 3px 6px 3px rgb(160 164 167 / 15%)",
    oracleCurrencySelectorPanelTextColor: "#000",
    oracleCurrencySelectorPanelBackgroundColor: "#FFF",
    currencySelectorBackgroundColorHover: "#EEE",
    poolCompositionBorderColor: "#f0f2f1",
    valueTextColor: "#444",
    newPanelShadow: "0px 3px 3px 0px rgb(160 164 167 / 30%), 0 5px 16px 5px rgb(160 164 167 / 15%)",
    investBackgroundColor: "#FFF",
    oracleResultTextColorPositive: "#1DDD94",
    oracleResultTextColorNegative: "#F3729A",
    walletBackgroundColor: "#FFF",
    walletTextColor: "#000",
	walletBorderColor: "#1DDD94",
	walletNotConnectedBorderColor: "#EA0067"
}

export const darkTheme = {
	notMainChainTextColor: "#FFF",
	notMainChainBackgroundColor: "red",
    body: "linear-gradient(#2E2E2E, #2E2E2E)",
    text: "#FFF",
    logo: logoDark,
    brandTextColor: "#FFF",
    brandTextColorHover: "#FFF",
	headerBackground: "linear-gradient(#2E2E2E, #2E2E2E)",
    oraclePanelBackgroundColor: "#2A2A2A",
    panelTextColor: "#FFF",
    panelBorderColor: "#252525",
    panelShadow: "0 3px 8px 0 rgb(6 6 6 / 30%), 0 20px 30px 15px rgb(6 6 6 / 15%)",
    inputPanelBackgroundColor: "#353837",
    inputPanelTextColor: "#FFF",
    inputPanelBorderColor: "#3F3F3F",
    inputPanelBorderColorHover: "#777",
    oracleButtonBackgroundColor: "#EA0067",
    oracleButtonTextColor: "#FFF",
    oracleButtonBackgroundNotReadyColor: "#444",
    oracleButtonTextNotReadyColor: "#FFF",
    currencyTextColor: "#FFF",
    currencyBackgroundColor: "#2A2A2A",
    emptyCurrencyTextColor: "#FFF",
    emptyCurrencyBackgroundColor: "#1DDD94",
    currencyShadow: "0 3px 3px 0 rgb(6 6 6 / 30%), 0 3px 6px 3px rgb(6 6 6 / 15%)",
	oracleCurrencySelectorPanelTextColor: "#FFF",
    oracleCurrencySelectorPanelBackgroundColor: "#2A2A2A",
    currencySelectorBackgroundColorHover: "#2A2A2A",
    valueTextColor: "#DDD",
	newPanelShadow: "0px 1px 1px 0px rgb(6 6 6 / 30%), 0 3px 8px 3px rgb(6 6 6 / 15%)",
    oracleResultTextColorPositive: "#1DDD94",
    oracleResultTextColorNegative: "#F3729A",
	walletBackgroundColor: "#333",
	walletTextColor: "#FFF",
	walletBorderColor: "#1DDD94",
	walletNotConnectedBorderColor: "#EA0067",
}